var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAxios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 31,
    viewBox: "0 0 119 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3062 29.074H62.3645V0.91626H55.3062V29.074Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.892 23.144C84.3772 23.144 87.6725 19.3009 87.6725 14.9869C87.6725 10.6725 84.3588 6.86599 79.892 6.86599C75.4067 6.86599 72.0932 10.6725 72.0932 14.9869C72.0932 19.3009 75.4067 23.144 79.892 23.144ZM79.9469 0.013916C88.4047 0.013916 95.2153 6.50341 95.2153 14.9325C95.2153 23.3977 88.35 30.0139 79.8736 30.0139C71.3973 30.0139 64.5322 23.4885 64.5322 15.0413C64.5322 6.61204 71.4892 0.013916 79.9469 0.013916ZM96.027 20.5586L102.503 19.0351C102.969 22.4184 105.455 23.6409 108.067 23.6409C110.661 23.6409 111.61 22.1173 111.61 20.9305C111.61 19.9739 111.055 19.0351 109.158 18.6632L105.205 17.9013C100.482 16.998 97.1363 14.0574 97.1363 9.54023C97.1363 4.15523 102.092 0.364382 107.691 0.364382C114.901 0.364382 117.871 4.8284 118.39 8.56615L112.039 10.3375C111.699 8.03458 110.268 6.36964 107.656 6.36964C105.401 6.36964 104.328 7.85758 104.328 8.99115C104.328 9.93001 104.775 11.0107 106.457 11.3295L110.572 12.1088C115.957 13.1364 118.909 16.3957 118.909 20.6294C118.909 25.2352 114.901 29.6636 108.032 29.6636C100.84 29.6636 96.9752 25.9259 96.027 20.5586Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15434 29.074H0.558105L13.119 0.91626H20.7516L8.15434 29.074Z",
    fill: "#495057"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8728 0.89917H26.1235L35.6816 14.6763L30.3631 22.3974L20.7813 0.915756H13.1479L25.7459 29.0743H33.8927L39.8438 20.148L45.7246 29.0743H53.9605L44.13 14.6763L53.5649 0.89917H44.9324L39.8438 9.23939L34.8728 0.89917Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxios);
export default __webpack_public_path__ + "static/media/axios.0c79eca9e33dc4b1b99fc40379ccc0b0.svg";
export { ForwardRef as ReactComponent };